// ng generate interceptor core/interceptors/auth
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(

      catchError((error: HttpErrorResponse) => {

        if (error.status === 401 && !req.url.includes('/auth/login')) {
          console.log('401');

          localStorage.removeItem("token");
          localStorage.removeItem("user");

          this.router.navigate(['/auth/login'], {
            queryParams: {},
          });
          document.location.reload();
        }

        return throwError(() => error);
      })

    );
  }
}
